
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M21 12C21 14.1337 20.242 16.1979 18.8611 17.8245C17.4803 19.4511 15.5665 20.5342 13.4611 20.8806C11.3558 21.227 9.19585 20.8142 7.36666 19.7157C5.53748 18.6173 4.15803 16.9047 3.47443 14.8835C2.79083 12.8623 2.84753 10.664 3.63444 8.68078C4.42134 6.69753 5.88724 5.05835 7.77063 4.05568C9.65402 3.05301 11.8324 2.75207 13.9171 3.20656C16.0018 3.66104 17.8572 4.84138 19.1523 6.537M19.1523 6.537V3.00832M19.1523 6.537H15.7407"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiRefresh",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
